__turbopack_context__.v({
  "container": "progressbar-module-scss-module__O9unBG__container",
  "fill": "progressbar-module-scss-module__O9unBG__fill",
  "label": "progressbar-module-scss-module__O9unBG__label",
  "track": "progressbar-module-scss-module__O9unBG__track",
});
